export default __webpack_public_path__ + "static/media/geofence_image_mobile.e97bdcbe.png";